import { CameraModelWithAutoFocus } from "../../Utils/Models/devices";

export const convertISOStrToLocaleTimeStr = (timezoneId: string, dateISO: string) => {
  try {
    const options: Intl.DateTimeFormatOptions = {
      timeZone: timezoneId || "US/Pacific",
      timeZoneName: "short",
    };
    return new Date(dateISO).toLocaleTimeString("en-US", options);
  } catch (e) {
    const options: Intl.DateTimeFormatOptions = {
      timeZoneName: "short",
    };
    return new Date(dateISO).toLocaleTimeString("en-US", options);
  }
};

export const convertISOStrToLocaleDateStr = (timezoneId: string, dateISO: string) => {
  try {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      timeZone: timezoneId || "US/Pacific",
    };
    return new Date(dateISO).toLocaleDateString("en-US", options);
  } catch (e) {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    return new Date(dateISO).toLocaleDateString("en-US", options);
  }
};

export function isCameraWithAutoFocus(model: string) {
  return (
    model === CameraModelWithAutoFocus.Model_TVS5L5M ||
    model === CameraModelWithAutoFocus.Model_TVS5L8M ||
    model === CameraModelWithAutoFocus.Model_Bullet_TVS5L8M
  );
}
